import { render, staticRenderFns } from "./stereo-component.vue?vue&type=template&id=3b887f17&scoped=true&"
import script from "./stereo-component.vue?vue&type=script&lang=js&"
export * from "./stereo-component.vue?vue&type=script&lang=js&"
import style0 from "./stereo-component.vue?vue&type=style&index=0&id=3b887f17&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b887f17",
  null
  
)

export default component.exports